import React from 'react';
import { RECHARGE_PLANS } from './rechargePlans';
import type { RechargePlan } from './rechargePlans';
import PlanCard from './PlanCard';

export interface RechargePlanCardsProps {
  language?: 'en' | 'zh';
  /** Theme sync with official landing page (light/dark). Default: dark. */
  isDarkMode?: boolean;
  /** 每个套餐底部按钮：弹窗内为支付；落地页可为进入实验室 */
  onPrimaryAction: (plan: RechargePlan) => void;
  loadingAmount?: number | null;
  /** 禁用所有按钮（未验证邮箱等） */
  disabled?: boolean;
  /** 覆盖按钮文案（落地页用「进入实验室」等） */
  actionLabelOverride?: { zh: string; en: string };
}

const RechargePlanCards: React.FC<RechargePlanCardsProps> = ({
  language = 'zh',
  isDarkMode = true,
  onPrimaryAction,
  loadingAmount = null,
  disabled = false,
  actionLabelOverride,
}) => {
  const visiblePlans = RECHARGE_PLANS.filter((p) => !p.hideInPlanCards);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 2xl:grid-cols-4 gap-5 lg:gap-6">
      {visiblePlans.map((plan) => (
        <PlanCard
          key={plan.id}
          plan={plan}
          language={language}
          isDarkMode={isDarkMode}
          onPrimaryAction={onPrimaryAction}
          loadingAmount={loadingAmount}
          disabled={disabled}
          actionLabelOverride={actionLabelOverride}
        />
      ))}
    </div>
  );
};

export default RechargePlanCards;
